import { render, staticRenderFns } from "./PptITextAttr.vue?vue&type=template&id=23165076&"
import script from "./PptITextAttr.vue?vue&type=script&lang=js&"
export * from "./PptITextAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23165076')) {
      api.createRecord('23165076', component.options)
    } else {
      api.reload('23165076', component.options)
    }
    module.hot.accept("./PptITextAttr.vue?vue&type=template&id=23165076&", function () {
      api.rerender('23165076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/PptITextAttr.vue"
export default component.exports